import { Component, OnInit, Input } from '@angular/core';
import { EstimateMark } from 'src/app/store/order/model';

@Component({
  selector: 'app-star',
  templateUrl: './star.component.html',
  styleUrls: ['./star.component.scss'],
  standalone: false,
})
export class StarComponent implements OnInit {
  @Input('type') public type: EstimateMark;

  public estimateMark = EstimateMark;

  constructor() {}

  ngOnInit(): void {}
}
